import React, {useState} from 'react'

import {
    Alert,
    Box,
    Button,
    ButtonGroup,
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    IconButton,
    List,
    Slide, Snackbar,
    Switch,
    Tab,
    Tooltip
} from "@mui/material";
import PersonPhotoIcon from "../../../assets/Images/photo1.png";
import ArrestIcon from "../../../assets/Images/ai1.png";
import InfoCopIcon from "../../../assets/Images/ic1.png";
import ETicketIcon from "../../../assets/Images/et1.png";
import ParkMobileIcon from "../../../assets/Images/pm1.png";
import ALPRIcon from "../../../assets/Images/alpr1.png";
import CADRMSIcon from "../../../assets/Images/Opencase1.png";
import CODISIcon from "../../../assets/Images/DNA1.png";
import TowingIcon from "../../../assets/Images/towing1.png";
import PrisonReleaseIcon from "../../../assets/Images/jail1.png";
import GunTraceIcon from "../../../assets/Images/WeaponTrace1.png";
import ShootingIcon from "../../../assets/Images/Shooting.png";
import ShootingSuspectIcon from "../../../assets/Images/ShootingRed.png";
import ShootingVictimIcon from "../../../assets/Images/ShootingGreen.png";
import NibinIcon from "../../../assets/Images/nibin1.png";
import NJGunTraceIcon from "../../../assets/Images/NjGunTrace1.png";
import PrisonParoleInactiveIcon from "../../../assets/Images/parole_Inactive.png";
import PrisonParoleActiveIcon from "../../../assets/Images/parole1.png";
import ViolentIcon from "../../../assets/Images/Violent1.png";
import HumanTrafficIcon from "../../../assets/Images/HumanTraffic1.png";
import ProfesionIcon from "../../../assets/Images/profession1.png";
import ReferralIcon from "../../../assets/Images/Referral1.png";
import ReferralRearrestedIcon from "../../../assets/Images/ReferralRearrested1.png";
import ArrestRecentIcon from "../../../assets/Images/aiRecent.png";
import PrisonReleaseRecentIcon from "../../../assets/Images/jailRecent.png";
import GunTraceRecentIcon from "../../../assets/Images/WeaponTraceTTC.png";
import NJGunTraceTriggerLockIcon from "../../../assets/Images/NjGunTraceTrigerLock.png";
import ProfileIcon from "../../../assets/Images/profile.png";
import DomViolenceIcon from "../../../assets/Images/domesticviolence.png";
import SexCrimeIcon from "../../../assets/Images/sexcrime.png";
import BTPersonReport from "../../shared/_BTPersonReport";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import { PostAdd, Close } from '@mui/icons-material';
import { TransitionProps } from '@mui/material/transitions';
import {
    ColumnDirective,
    ColumnsDirective,
    ColumnMenu,
    GridComponent,
    Grid,
    Inject,
    Page,
    Sort,
    Filter,
    DetailRow,
    ExcelExport,
    PdfExport,
    Toolbar,
    Search, ExcelExportProperties,
    Resize, Reorder, SortSettingsModel, CommandColumn
} from '@syncfusion/ej2-react-grids';
import { ClickEventArgs } from '@syncfusion/ej2-navigations';
import NJTracePerson from './_searchResultsNJTracePerson'
import { GetNJTrace, RunSharedToken, SendNJTracetoATF, SetNJTrace } from '../../../services/account.service';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import NJTraceInputForm from './_njtraceInputForm';
import { JAOS } from '../../../services/JAOS.service';
import { NJTraceObject, NJTraceMainObject } from "../../../interfaces/Detail/NJTraceDetail.interface"


interface SearchResultsProps {
    SubmitSearch:any
    NJTraceMain: any[],
    NJTraceCase: any[],
    Persons: any[],
    passedData?: any | null
    isNew?: boolean | null
}

const SearchResults: React.FC<SearchResultsProps> = ({ NJTraceMain, NJTraceCase, Persons, passedData = null, isNew = false, SubmitSearch }) => {
    const [formatData, setFormatData] = React.useState<any>([])
    const [Data, setData] = React.useState<NJTraceObject>({})
    const [openDialog, setOpenDialog] = React.useState(false);
    const [tabValue, setTabValue] = React.useState('1');
    const [editTabName, setEditTabName] = React.useState('New NJTrace');
    const [alertOpen, setAlertOpen] = React.useState<boolean>(false)
    const [alertText, setAlertText] = React.useState<string>("") 
    const [alertType, setAlertType] = React.useState<any>("success")
    const [hash, setHash] = React.useState<string | null>(null);


    //initialize object to keep track of status while page is not refreshed. Couldn't use state variable in synfusion table
    let updatedWeaponStatus=[{ID:0, WEAPONSTATUS:""}]
    let updatedPossesorStatus=[{ID:0, PROCESSORSTATUS:""}]

    let grid:GridComponent | null;

    const handleDataTyping = () => {
        if (isNew)
            setTabValue('2');
        else if (NJTraceMain) {
            let tempP: any = [...NJTraceMain]
            for (let p of tempP) {
                if (p.CreateDate) {
                    p.CreateDate = new Date(p.CreateDate)
                }
                if (p.OffenseDate) {
                    p.OffenseDate = new Date(p.OffenseDate)
                }
                if (p.ATF_trace_ReceivedDate) {
                    p.ATF_trace_ReceivedDate = new Date(p.ATF_trace_ReceivedDate)
                }
            }
            setFormatData(tempP)
            checkPassedData();
        }
        else if (passedData) {
            let l = new JAOS();
            let hashID = l.objToStack(passedData);
            setHash(hashID);
            setEditTabName('Edit NJTrace');
            setTabValue('2');
        }
    }

    //function useQuery() {
    //    return new URLSearchParams(useLocation().search);
    //}

    //let query = useQuery();
    //let [id, setID] = React.useState<any>(query.get("ID"))
    //let [dept, setDept] = React.useState<any>(query.get("Dept"))
    //let [status, setStatus] = React.useState<any>(query.get("EditStatus"))

    //const handleGetExpiryToken = () => {
    //    RunSharedToken(id, dept).then((res) => {
    //        if (res.AuthToken && res.AuthToken.length > 0) {
    //            if (localStorage.getItem('user') == null) {
    //                localStorage.setItem('user', res.AuthToken)
    //            }
    //        }
    //        if (res.AnyData) {
    //            //http://localhost:3000/tools/njtrace/?ID=EAgent&Dept=NJTrace&EditStatus=NEW
    //            if (status === 'NEW')
    //                setTabValue('2');
    //        }
    //    })
    //}

    const checkPassedData = async () => {
        if (passedData && NJTraceMain.length > 0) {
            setOpenDialog(true);
        }
        else {
            setTabValue('1');
        }
    };

    const handleNJTraceSubmit = (type:string, record:any = null) => {
        setHash(null);
        setEditTabName('New NJTrace');
        setTabValue('1');
        setAlertOpen(false)
        //console.log(type, record)
        switch(type){
            case 'New':
                setAlertOpen(true)
                setAlertType("success")
                setAlertText("New Record: " + record?.main?.CaseNumber + " Successful")
            break
            case 'Edit':
                setAlertOpen(true)
                setAlertType("success")
                setAlertText("Update Record: " + record?.main?.CaseNumber + " Successful")
                break            
        }
        
    };

    React.useEffect(() => {
        handleDataTyping()
    }, [NJTraceMain])
    
    const getNJTraceDetailRow = (NJTraceMain: any) => {
        //let NJTraceCaseInfo = NJTraceCase?.filter((x) => x.FTS_ID === NJTraceMain.FTS_ID)
        let PersonsInfo = Persons?.filter((x) => x.FTS_ID === NJTraceMain.FTS_ID)
        return (
            <div>
                {/*<NJTraceCaseDisplay NJTraceCase={NJTraceCaseInfo} />*/}
                <NJTracePerson NJTracePerson={PersonsInfo}/>
            </div>
        )
    }

    const GridToolsClick = (args: ClickEventArgs) => {
        if (grid && args.item.text === "Excel Export") {
            let excelProp: ExcelExportProperties = {}
            excelProp.fileName = 'NJTrace.xlsx'
            grid.excelExport(excelProp);
        }
    }

    const actionTemplate = (njtrace: any): any => {
        return (
            <span>
                <ButtonGroup>
                    <Tooltip title="Edit" placement="top" arrow>
                        <IconButton onClick={() => editNJTrace(njtrace)}><EditIcon /></IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" placement="top" arrow>
                        <IconButton onClick={() => deleteNJTrace(njtrace)}><DeleteIcon /></IconButton>
                    </Tooltip>
                </ButtonGroup>
            </span>);
    }

    const statusWeaponTemplate = (njTrace: any): any => {
        return (
            <ReactiveSlider1 njTrace={njTrace} />
        )
    }

    const statusPossessorTemplate = (njTrace: any): any => {
        return (
            <ReactiveSlider2 njTrace={njTrace} />
        )
    }

    const ReactiveSlider1: React.FC<any> = ({ njTrace }) => {
        let [weaponstatus, setweaponStatus] = useState<string>(njTrace?.WeaponStatus);
        let [newPossessorStatus, setpossessorStatus] = useState<string>(njTrace?.PossessorStatus); 
        const setNJTraceStatus = async (e: any) => { 
            //linked value change to event 
            let tempWeaponStatus="";
            if(e){
                tempWeaponStatus = "COMPLETE"
            }
            else{
                tempWeaponStatus = "PENDING"
            }
            //updatedWeaponStatus is an array to keep track of changes
            //if object doesn't exist in the array 
            if(!updatedWeaponStatus.some(res => res.ID === njTrace.MainID))
            {
                //add it with the ID and status selected 
                updatedWeaponStatus.push({ID: njTrace.MainID, WEAPONSTATUS: tempWeaponStatus})   
            }
            else {
                //update list with the status selected
                for (let wStatus of updatedWeaponStatus){
                    if(wStatus.ID === njTrace.MainID){
                        wStatus.WEAPONSTATUS = tempWeaponStatus

                    }
                }         
            }

            //Before Setting NjtraceMain check updatedPossesorStatus array to get the latest value
            for(let item of updatedPossesorStatus){
                if(item.ID != 0)
                    if(item.ID === njTrace.MainID && item.PROCESSORSTATUS !== newPossessorStatus)
                        newPossessorStatus = item.PROCESSORSTATUS
            }
            
            let njTraceMain: NJTraceMainObject = { ID: njTrace.MainID, FTS_ID: njTrace.FTS_ID, FTS_IDOriginal: njTrace.FTS_ID, WeaponStatus: tempWeaponStatus, PossessorStatus: newPossessorStatus };
            let r = await SetNJTrace({ main: njTraceMain })
            if (!r?.IsValid) {
                tempWeaponStatus = weaponstatus; 
            }
            
            setweaponStatus(tempWeaponStatus)
            setpossessorStatus(newPossessorStatus)
            SendNJTraceToATF(njTraceMain)
            


        }        
        
        return (
            <span>
                <FormControl component="fieldset" variant="standard">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch onChange={(e) => setNJTraceStatus(e.target.checked)} checked={weaponstatus === "COMPLETE" } />
                            }
                            label={weaponstatus === "COMPLETE" ? "COMPLETE" : "PENDING"}
                        />
                    </FormGroup>
                </FormControl>
            </span>
        );
    }

    const ReactiveSlider2: React.FC<any> = ({ njTrace }) => {
        let [possessorStatus, setpossessorStatus] = useState<string>(njTrace?.PossessorStatus);   
        let [newWeaponStatus, setweaponStatus] = useState<string>(njTrace?.WeaponStatus);  
        const setNJTraceStatus = async (e: any) => {

            //let newPossessorStatus = possessorStatus === "COMPLETE" ? "PENDING" : "COMPLETE"

            //linked value change to event 
            let tempPossessorStatus="";
            if(e){
                tempPossessorStatus = "COMPLETE"
            }
            else{
                tempPossessorStatus = "PENDING"
            }
            //updatedPossesorStatus is an array to keep track of changes
            //if object doesn't exist in the array 
            if(!updatedPossesorStatus.some(res => res.ID === njTrace.MainID))
            {
                //add it with the ID and status selected 
                updatedPossesorStatus.push({ID: njTrace.MainID, PROCESSORSTATUS: tempPossessorStatus}) 
            }
            //update list with the status selected
            else {
                for (let pStatus of updatedPossesorStatus){
                    if(pStatus.ID === njTrace.MainID){
                        pStatus.PROCESSORSTATUS = tempPossessorStatus
                    }
                }         
            }
            for(let item of updatedWeaponStatus){
                if(item.ID != 0) 
                    if(item.ID === njTrace.MainID && item.WEAPONSTATUS !== newWeaponStatus)
                        newWeaponStatus = item.WEAPONSTATUS

            }
            let njTraceMain: NJTraceMainObject = { ID: njTrace.MainID, FTS_ID: njTrace.FTS_ID, FTS_IDOriginal: njTrace.FTS_ID, WeaponStatus: newWeaponStatus, PossessorStatus: tempPossessorStatus};
            let r = await SetNJTrace({ main: njTraceMain })
            if (!r?.IsValid) {
                tempPossessorStatus = possessorStatus;
            }  
            setpossessorStatus(tempPossessorStatus);
            setweaponStatus(newWeaponStatus)
            SendNJTraceToATF(njTraceMain)
        }

        return (
            <span>
                <FormControl component="fieldset" variant="standard">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch onChange={(e) => setNJTraceStatus(e.target.checked)} checked={possessorStatus === "COMPLETE"} />
                            }
                            label={possessorStatus === "COMPLETE" ? "COMPLETE" : "PENDING"}
                        />
                    </FormGroup>
                </FormControl>
            </span>
        );
    }

    const editNJTrace = (njTrace: any) => {
        let njTraceMain: NJTraceMainObject = { ID: njTrace.MainID, FTS_ID: njTrace.FTS_ID, FTS_IDOriginal: njTrace.FTS_ID,};

        let l = new JAOS();
        let hashID = l.objToStack(njTraceMain);
        setHash(hashID);
        setEditTabName('Edit NJTrace');
        setTabValue('2');
    }

    const deleteNJTrace = async (njTrace: any) => {
        let p = { ...njTrace }
        if (window.confirm("Remove This NJTrace Record Permanently?")) {
            let sStatus = true;
            let njTraceMain: NJTraceMainObject = { ID: njTrace.MainID, FTS_ID: njTrace.FTS_ID, FTS_IDOriginal: njTrace.FTS_ID, Deleted: sStatus };
            
            let r = await SetNJTrace({main:njTraceMain})
            if (r.IsValid) {
                setAlertType("success")
                setAlertOpen(true)
                setAlertText("Delete Successful (Changes Will Take Effect After The Next Search)")
            }
            else {
                alert(r.AnyData?.ErrorMessage)
            }                  
        }
    }

    const SendNJTraceToATF = async (njTrace: any) => {
        //console.log('SendNJTraceToATF: ', njTrace.ID, njTrace?.WeaponStatus, njTrace?.PossessorStatus)
        let tempP: any = [...NJTraceMain]
        if (njTrace?.WeaponStatus === "COMPLETE" && njTrace?.PossessorStatus === "COMPLETE" && window.confirm("Do you want to submit NJTrace record to ATF(eTrace)?")) {
            //let njTraceMain: NJTraceMainObject = { ID: njTrace.ID, FTS_ID: njTrace.FTS_ID, FTS_IDOriginal: njTrace.FTS_ID, WeaponStatus: njTrace?.PossessorStatus, PossessorStatus: njTrace?.WeaponStatus };
            let r = await SendNJTracetoATF({ main: njTrace})
            if (r?.IsValid) {
                setAlertType("info")
                setAlertOpen(true)
                //setAlertText("NJTrace record was sent to ATF. Details: " + r?.ErrorMessages)  //show ATF traceID
                setAlertText("NJTrace record was sent to ATF for case #: "+ r?.Main?.CaseNumber + ".") 
                //may need to update data for atfid here
            }
            else {
                let errString=""
                let valid = true
                try{
                    let tempE = JSON.parse(r.ErrorMessages)
                    if(tempE.traces){
                        for(let trace of tempE.traces){
                            for(let error of trace.messages.errors){
                                errString += error.description +"\n"
                            }
                        }
                    }
                }
                catch(e){
                    console.log(e)
                    valid = false
                }
                if(valid){
                    alert("Error! Please review the following errors in the form before sending to ATF:\n"+ errString) 
                }
                else{
                    alert(r?.ErrorMessages)
                }
            }          
                
        }
        for(let item of tempP){
            if (item.MainID === njTrace.ID){
                item.WeaponStatus = njTrace.WeaponStatus
                item.PossessorStatus = njTrace.PossessorStatus
            }
        }
        setFormatData(tempP)
        
    }
    
    /*const handleDialogClose = () => {
        setNJTrace(false)
    };*/

    const Transition = React.forwardRef(function Transition(
        props: TransitionProps & {
            children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>,
        ) {
        return <Slide direction="up" ref={ref} {...props} />;
    });

    const expandRow = () => {
        if (grid) {
            const selectedrowindex: number[] = grid.getSelectedRowIndexes()
            for (let idx of selectedrowindex) {

                grid.detailRowModule.expand(idx)
            }
        }
    }

    let sortSettings: SortSettingsModel = {
        columns: [
            { field: 'CreateDate', direction: 'Descending' }
        ]
    };

    const handleTabChange = (event: React.SyntheticEvent , newValue: string) => {
        if (newValue == '1') {
            setHash(null);
            setEditTabName('New NJTrace');
        }

        setTabValue(newValue);
    };

    return (
        <div className="m-5 p-5">
            <Snackbar open={alertOpen} autoHideDuration={6000} onClose={ () => { setAlertOpen(false)}}>
                <Alert onClose={() => { setAlertOpen(false) }} severity={alertType} sx={{ width: '100%' }}>
                    {alertText}
                </Alert>
            </Snackbar>
            <Box className="pt-3" style={{ justifyContent:'center' }}>
                <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleTabChange} variant="fullWidth">
                            <Tab icon={<List />} label="List View"  value={'1'}/>
                            <Tab icon={<PostAdd />} label={editTabName} value={'2'} />
                        </TabList>
                    </Box>
                    <TabPanel value='1'>
                        <div className={"pl-10 pr-10 mt-5"}>
                            {NJTraceMain && NJTraceMain?.length > 0 ? <>
                                <h4 className={"font-bold pl-5"}> {NJTraceMain?.length} Records Found</h4>
                                <GridComponent
                                    dataSource={formatData}
                                    allowPaging={true}
                                    pageSettings={{ pageSize: 25, pageSizes: [10, 25, 50, 100] }}
                                    allowSorting={true}
                                    sortSettings={sortSettings}
                                    allowMultiSorting={true}
                                    allowFiltering={true}
                                    filterSettings={{ type: 'CheckBox' }}
                                    detailTemplate={getNJTraceDetailRow}
                                    allowTextWrap={true}
                                    textWrapSettings={{ wrapMode: 'Both' }}
                                    allowExcelExport={true}
                                    allowPdfExport={true}
                                    toolbar={['ExcelExport', 'Search']}
                                    toolbarClick={GridToolsClick}
                                    ref={g => grid = g}
                                    selectionSettings={{
                                        persistSelection: true,
                                        type: "Multiple",
                                        //checkboxOnly: true,
                                        mode: "Row"}}
                                    //rowSelecting={(event: any) => { console.log(event) }}
                                    //rowSelected={(event: any) => { expandRow() }}
                                    //allowSelection={true}
                                    allowResizing={true}
                                    rowHeight={24}
                                >
                                <ColumnsDirective>
                                    <ColumnDirective template={actionTemplate} headerText='Action' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='WeaponStatus' template={statusWeaponTemplate} headerText='Weapon Status' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='PossessorStatus' template={statusPossessorTemplate} headerText='Possessor Status' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='CreateDate' headerText='Entry Date' format={{ type: 'date', format: 'MM/dd/yyyy' }} width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='OffenseDate' headerText='Report Date' format={{ type: 'date', format: 'MM/dd/yyyy' }} width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='AgencyCaseNo' headerText='Case #' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='Agency' headerText='Agency' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='IncidentCity' headerText='Incident City' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='IncidentCounty' headerText='Incident County' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='ATF_trace_id' headerText='ATF ID' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                    <ColumnDirective field='ATF_trace_ReceivedDate' headerText='ATF Received' format={{ type: 'date', format: 'MM/dd/yyyy' }} width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />
                                   {/* <ColumnDirective template={IndicatorTemplate} headerText='Indicator' width={140} minWidth={140} maxWidth={140} customAttributes={{ class: ['e-attr'] }} />  */}                      
                                </ColumnsDirective>
                                <Inject services={[ColumnMenu, Sort, Page, Filter, DetailRow, Toolbar, ExcelExport,PdfExport,Search, Resize, Reorder]} />
                            </GridComponent>
                            </>:<div className="font-bold text-center text-lg pt-3">NO Matching Records Found</div>}
                        </div>
                    </TabPanel>
                    <TabPanel value='2'>
                        <NJTraceInputForm handleReportSubmit={handleNJTraceSubmit} isEdit={true} trace={hash} />
                    </TabPanel>
                </TabContext>                
            </Box>
        </div>
    )
};

export default SearchResults

function useQuery() {
    throw new Error('Function not implemented.');
}
